import { buildYourOwnFunctionalPackages } from "build-your-own";

import type {
  EnvironmentSettings,
  Experience,
  ExperienceApi,
} from "@inter-ikea-space-platform/experience";
import {
  BathroomAccessoriesExperience,
  BathroomBenchesExperience,
  BathroomFloorCabinetsExperience,
  BathroomLaundryExperience,
  BathroomLegsExperience,
  BathroomLightingExperience,
  BathroomMirrorsExperience,
  BathroomMiscExperience,
  BathroomShelvesExperience,
  BathroomShowersExperience,
  BathroomSinksExperience,
  BathroomStoolsExperience,
  BathroomStorageExperience,
  BathroomTapsExperience,
  BathroomTextilesExperience,
  BathroomToiletsExperience,
  BathroomTrolleysExperience,
  BathroomWashstandsExperience,
  BathroomWorktopsExperience,
  EnhetStorageExperience,
  ModularOutdoorSofaBuildMode,
  spaceRangeExperiences,
  WallCabinetsExperience,
  WashstandBuildMode,
} from "@inter-ikea-space-platform/range";
import { SpacePlanningExperience } from "@inter-ikea-space-platform/space-planning";
import { storageOnePackages } from "@inter-ikea-space-platform/storageone";

export const bathroomRangeExperienceList = [
  BathroomStorageExperience,
  BathroomAccessoriesExperience,
  BathroomMiscExperience,
  BathroomLegsExperience,
  BathroomTrolleysExperience,
  WallCabinetsExperience,
  BathroomStoolsExperience,
  BathroomShowersExperience,
  BathroomSinksExperience,
  BathroomTapsExperience,
  BathroomToiletsExperience,
  BathroomWashstandsExperience,
  BathroomWorktopsExperience,
  BathroomBenchesExperience,
  BathroomStorageExperience,
  BathroomFloorCabinetsExperience,
  BathroomLaundryExperience,
  BathroomShelvesExperience,
  BathroomMirrorsExperience,
  BathroomLightingExperience,
  BathroomTextilesExperience,
  EnhetStorageExperience,
];

// should only load when opening old designs before bathroom was split up into smaller packages and renamed to bathroom-experience,
export const deprecatedBathroomExperience = (settings: EnvironmentSettings): Experience => ({
  id: "bathroom",
  consumes: [...bathroomRangeExperienceList.map((experience) => experience(settings).id)],
  roomTypes: undefined, // should not be linked to any room type
  onReady: () => {},
});

export const rangePackages = (settings: EnvironmentSettings): Experience[] => {
  const cutoutFeature = {
    id: "cutout-feature",
    onReady: (api: ExperienceApi) => {
      // breaks unit tests if not imported async
      import("@inter-ikea-core/core-hole-cutting-feature")
        .then(({ VisualCuttingUtilities }) => {
          VisualCuttingUtilities.addProductManagerCatalogMetadataConversion(api.core.services);
          VisualCuttingUtilities.addVisualCuttingSystem(api.core.services);
        })
        .catch(() => {});
    },
  };

  return [
    SpacePlanningExperience(),
    ...spaceRangeExperiences(settings),

    ...storageOnePackages(settings, ["storageone-pax", "storageone-smastad"]),

    ModularOutdoorSofaBuildMode(),
    WashstandBuildMode(),

    // shared(?) functional package
    cutoutFeature,
  ];
};

export const functionalPackages = (settings: EnvironmentSettings): Experience[] =>
  buildYourOwnFunctionalPackages(settings);
